import React, { useContext } from "react";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";

function ContactCardGlassy({ preview, Hcolor }) {
  const [cardData] = useContext(CardContext);

  const { personalDetails, contactDetails, emailList, phoneNumbers } = cardData;
  const Highlightcolor = Hcolor ? Hcolor : "#D9D9D9";
  const Textcolor = cardData?.Textcolor ? cardData?.Textcolor : "#FFFFFF";
  const BtIColor = cardData?.BtIColor ? cardData?.BtIColor : "#FFFFFF";
  // console.log(Hcolor);
  // const { personalDetails, Hcolor, contactDetails } = useSelector(
  //   (state) => state.cardReducer
  // );
  const hexToRgba = (color, alpha) => {
    const hex = String(color ?? "").replace("#", "");
    if (!hex || (hex.length !== 3 && hex.length !== 6) || !/^[0-9a-fA-F]+$/.test(hex)) return "";
    const full = hex.length === 3 ? hex.split("").map((c) => c + c).join("") : hex;
    const r = parseInt(full.substring(0, 2), 16);
    const g = parseInt(full.substring(2, 4), 16);
    const b = parseInt(full.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
  const glassBg = {
    backgroundColor: hexToRgba(Highlightcolor, 0.18) || hexToRgba("#D9D9D9", 0.18),
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
  };
  const borderStyle = { borderBottom: `1px solid ${hexToRgba(Textcolor, 0.3) || "rgba(255,255,255,0.3)"}` };
  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${personalDetails?.secondaryEmail}`;
    e.preventDefault();
  };
  return (
    <>
      <div className="flex items-center justify-center">
        <div>
          <Link to={preview ? `tel:+${personalDetails?.phone}` : ""}>
            <div className="glassy-panel rounded-[16px] p-2" style={glassBg}>
              <p className="text-[19px] font-bold text-center" style={{ color: Textcolor }}>
                Contact Info
              </p>
              <div style={borderStyle}>
                <div className="flex items-center justify-center h-[44px]">
                  <svg
                    width="25"
                    height="26"
                    viewBox="0 0 25 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.0596 12.822C24.0596 19.7256 18.687 25.322 12.0596 25.322C5.43215 25.322 0.0595703 19.7256 0.0595703 12.822C0.0595703 5.91846 5.43215 0.322021 12.0596 0.322021C18.687 0.322021 24.0596 5.91846 24.0596 12.822Z"
                      fill="#D9D9D9"
                      fill-opacity="0.2"
                    />
                    <path
                      d="M16.2783 19.3845C15.6683 19.3845 14.8114 19.1777 13.5283 18.5056C11.968 17.6853 10.7611 16.928 9.20924 15.4769C7.71299 14.0751 6.98487 13.1674 5.9658 11.429C4.81455 9.46607 5.0108 8.43716 5.23018 7.99741C5.49143 7.47183 5.87705 7.15747 6.37549 6.84546C6.6586 6.67157 6.9582 6.5225 7.27049 6.40015C7.30174 6.38755 7.3308 6.37554 7.35674 6.3647C7.51143 6.29937 7.7458 6.20064 8.04268 6.30611C8.2408 6.37583 8.41768 6.51851 8.69455 6.77486C9.26237 7.29986 10.0383 8.46909 10.3246 9.04331C10.5167 9.43033 10.6439 9.68579 10.6442 9.97232C10.6442 10.3078 10.4642 10.5665 10.2458 10.8457C10.2049 10.8981 10.1642 10.9482 10.1249 10.9968C9.88705 11.2898 9.83487 11.3745 9.86924 11.5256C9.93893 11.8294 10.4586 12.7338 11.3127 13.5328C12.1667 14.3317 13.1036 14.7881 13.4289 14.8532C13.5971 14.8869 13.6892 14.8359 14.0117 14.605C14.058 14.5719 14.1055 14.5377 14.1552 14.5034C14.4883 14.271 14.7514 14.1067 15.1008 14.1067H15.1027C15.4067 14.1067 15.6671 14.2303 16.0983 14.4342C16.6608 14.7002 17.9455 15.4183 18.5089 15.9512C18.783 16.2102 18.9358 16.3754 19.0105 16.5609C19.123 16.8401 19.0171 17.0589 18.948 17.2054C18.9364 17.2297 18.9236 17.2564 18.9102 17.286C18.7786 17.5782 18.6187 17.8585 18.4324 18.1233C18.1002 18.5891 17.7636 18.9498 17.2017 19.195C16.9132 19.3229 16.5975 19.3877 16.2783 19.3845Z"
                      fill={BtIColor}
                    />
                  </svg>
                </div>
                {personalDetails?.phone && (
                  <p className="text-[14px] max-w-[197px] font-medium text-center" style={{ color: Textcolor }}>
                    +{personalDetails?.phone ? personalDetails.phone : ""}
                  </p>
                )}

                {personalDetails?.secondaryPhone && (
                  <p className="text-[14px] max-w-[197px] font-medium text-center" style={{ color: Textcolor }}>
                    +
                    {personalDetails?.secondaryPhone
                      ? personalDetails.secondaryPhone
                      : ""}
                  </p>
                )}

                {phoneNumbers?.map((phone, index) => (
                  <div className="mt-2" key={index}>
                    <div
                      className={`flex ${
                        phone?.alignCol ? "flex-col gap-1" : "flex-row gap-1"
                      } break-words overflow-hidden`}
                    >
                      {phone?.showLabel && (
                        <label className="break-words">{phone?.label}:</label>
                      )}

                      <Link
                        to={preview ? `tel:+${phone?.number}` : ""}
                        className="break-all overflow-hidden text-ellipsis"
                      >
                        <p className="text-[14px] max-w-[197px] font-medium text-center" style={{ color: Textcolor }}>
                          +{phone?.number}
                        </p>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              <div style={borderStyle}>
                <div className="flex items-center justify-center h-[44px]">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 12.5C24 19.4036 18.6274 25 12 25C5.37258 25 0 19.4036 0 12.5C0 5.59644 5.37258 0 12 0C18.6274 0 24 5.59644 24 12.5Z"
                      fill="#D9D9D9"
                      fill-opacity="0.2"
                    />
                    <path
                      d="M19.3142 10.141V16.6571C19.3142 17.2633 19.0734 17.8447 18.6448 18.2734C18.2161 18.702 17.6347 18.9428 17.0285 18.9428H6.97138C6.36517 18.9428 5.78379 18.702 5.35514 18.2734C4.92648 17.8447 4.68567 17.2633 4.68567 16.6571V10.141L11.7677 14.3083C11.8381 14.3498 11.9183 14.3717 12 14.3717C12.0816 14.3717 12.1618 14.3498 12.2322 14.3083L19.3142 10.141ZM17.0285 7.05713C17.5909 7.05704 18.1337 7.26431 18.5528 7.63929C18.972 8.01427 19.2382 8.53063 19.3005 9.08959L12 13.384L4.69938 9.08959C4.7617 8.53063 5.02791 8.01427 5.44708 7.63929C5.86626 7.26431 6.40896 7.05704 6.97138 7.05713H17.0285Z"
                      fill={BtIColor}
                    />
                  </svg>
                </div>
                <p className="text-[14px] font-medium text-center overflow-auto w-[150px] scrollbar-hide" style={{ color: Textcolor }}>
                  <Link onClick={preview ? shareMail : ""}>
                    {personalDetails?.email ? personalDetails.email : ""}
                  </Link>

                  <div className="mt-2">
                    <Link onClick={preview ? shareMail2 : ""}>
                      {personalDetails?.secondaryEmail
                        ? personalDetails.secondaryEmail
                        : ""}
                    </Link>
                  </div>
                  {emailList?.map((email) => {
                    return (
                      <div className="mt-2">
                        {/* <Link onClick={preview ? shareMail2 : ""}>
                      {personalDetails?.secondaryEmail
                        ? personalDetails.secondaryEmail
                        : ""}
                    </Link> */}
                        <div
                          className={`flex ${
                            email?.alignCol
                              ? "flex-col gap-1"
                              : "flex-row gap-1"
                          }  break-words overflow-hidden`}
                        >
                          {email?.showLabel && (
                            <label className="break-words">
                              {email?.label} :
                            </label>
                          )}
                          <Link
                            to={preview ? `mailto:${email?.email}` : ""}
                            className="break-all overflow-hidden text-ellipsis"
                          >
                            {email?.email}
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </p>
              </div>
              <div className="">
                <div className="flex items-center justify-center h-[44px]">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 12.5C24 19.4036 18.6274 25 12 25C5.37258 25 0 19.4036 0 12.5C0 5.59644 5.37258 0 12 0C18.6274 0 24 5.59644 24 12.5Z"
                      fill="#D9D9D9"
                      fill-opacity="0.2"
                    />
<path
                      d="M11.7806 4.48596C8.69604 4.48596 6.20129 6.98071 6.20129 10.0653C6.20129 14.2497 11.7806 20.4268 11.7806 20.4268C11.7806 20.4268 17.3599 14.2497 17.3599 10.0653C17.3599 6.98071 14.8651 4.48596 11.7806 4.48596ZM11.7806 12.0579C11.2521 12.0579 10.7453 11.8479 10.3716 11.4742C9.99792 11.1006 9.78799 10.5937 9.78799 10.0653C9.78799 9.53679 9.99792 8.28259 10.3716 8.65628C10.7453 8.28259 11.2521 8.07265 11.7806 8.07265C12.3091 8.07265 12.8159 8.28259 13.1896 8.65628C13.5633 9.02996 13.7732 9.53679 13.7732 10.0653C13.7732 10.5937 13.5633 11.1006 13.1896 11.4742C12.8159 11.8479 12.3091 12.0579 11.7806 12.0579Z"
                      fill={BtIColor}
                    />
                  </svg>
                </div>
                <p className="text-[14px] text-center font-medium overflow-auto w-[150px] scrollbar-hide" style={{ color: Textcolor }}>
                  {" "}
                  {contactDetails?.address
                    ? contactDetails.address
                    : "2709 Hwy 51,Janesville"}
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div></div>
    </>
  );
}

export default ContactCardGlassy;
